var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.disabled ? 'text--disabled' : _vm.getEtapaClass(_vm.etapa)},[_vm._v(" "+_vm._s(_vm.getEtapaNome(_vm.etapa))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }